<h1 mat-dialog-title> {{'endpoint_selectEndpointDialog_title' | lbTranslateFromKey}} </h1>
<div mat-dialog-content>
    <mat-selection-list  [multiple]="false">
        <mat-list-option *ngFor="let endpoint of data.endpoints"  (click)="onConfirm(endpoint.endpointId)">
            {{endpoint.name | lbTranslateFromObject}}
        </mat-list-option>
    </mat-selection-list>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onCancel()"> {{'endpoint_confirmDialog_cancel_no' | lbTranslateFromKey}}</button>
</div>
